"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Calendar } from "@/components/ui/calendar";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useState } from "react";
export default function ScheduleACall() {
  const [date, setDate] = useState<Date | undefined>(new Date());
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-12 items-center">
          {}
          <div ref={leftRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-scroll)] ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-[10px]"}`}>
            <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
              Schedule Your Free Consultation
            </h2>
            <p className="text-base md:text-lg text-muted-foreground mb-6">
              Select a convenient date and time to discuss your social media marketing needs. Our team will reach out to you within 24 hours to confirm your appointment.
            </p>
            <p className="text-sm text-muted-foreground">
              During the consultation, we'll review your current social media presence, discuss your goals, and show you how our affordable video solutions can boost your brand visibility.
            </p>
          </div>

          {}
          <div ref={rightRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-scroll)] ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-[10px]"}`}>
            <Card className="relative overflow-hidden border-2 border-transparent bg-gradient-to-br from-primary/10 via-secondary/10 to-accent/10 p-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-[6px] hover:shadow-[0_0_32px_rgba(255,165,0,0.3)] focus-within:-translate-y-[6px] focus-within:shadow-[0_0_32px_rgba(255,165,0,0.3)]">
              <div className="rounded-lg bg-background p-4">
                <SafeHydrate><Calendar mode="single" selected={date} onSelect={setDate} className="mx-auto" disabled={date => date < new Date() || date < new Date("1900-01-01")} /></SafeHydrate>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}